import { combineReducers, configureStore } from '@reduxjs/toolkit'
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import { authReducer } from '../Slice/Auth/authSlice'
import { userReducer } from '../Slice/User/userSlice'
import cartReducer from '../Slice/Cart/cartSlice'
import checkoutReducer from '../Slice/Checkout/checkoutSlice'
import booksReducer from "../Slice/Books/bookSlice";

// import thunk from 'redux-thunk';



const persistConfig = {
    key: 'root',
    storage,
}

const rootReducer = combineReducers({
    auth: authReducer,
    user: userReducer,
    cart: cartReducer,
    books: booksReducer,
    checkout: checkoutReducer
});

const persistedReducer = persistReducer(persistConfig, rootReducer)


export const store = configureStore({
    reducer: persistedReducer,
    devTools: process.env.NODE_ENV !== 'production',
    // middleware: [thunk]

})


export const persistor = persistStore(store)
